import { useEffect } from 'react'
import { READY_EVENT, notifyAppReady } from './nativeBridge'

/**
 * Сказать Flutter-оболочке, что первый экран нарисован, — она уберёт сплэш.
 * Зовём на кадре после монтирования, а потом ещё раз, когда мост готов и когда
 * страница догрузилась: если оболочка подставит `notifyAppReady` позже первого
 * кадра, первый вызов пройдёт мимо, а сплэш провисит 10 секунд. Повторы
 * оболочка не считает. Вне оболочки все вызовы ничего не делают.
 */
export function useAppReady(): void {
  useEffect(() => {
    const frame = window.requestAnimationFrame(notifyAppReady)
    window.addEventListener(READY_EVENT, notifyAppReady)
    window.addEventListener('load', notifyAppReady)
    return () => {
      window.cancelAnimationFrame(frame)
      window.removeEventListener(READY_EVENT, notifyAppReady)
      window.removeEventListener('load', notifyAppReady)
    }
  }, [])
}
